import { render, staticRenderFns } from "./messageRecharge.vue?vue&type=template&id=8978a372&scoped=true&"
import script from "./messageRecharge.vue?vue&type=script&lang=js&"
export * from "./messageRecharge.vue?vue&type=script&lang=js&"
import style0 from "./messageRecharge.vue?vue&type=style&index=0&id=8978a372&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8978a372",
  null
  
)

export default component.exports